import { AbstractBaseService } from "../ensue-react-system/utilities/base-service";
import { User } from "../commons/models/user";
import {UserStatusEnum} from "../commons/enums/user-status-enum";

export interface IUserDTO {
  firstName: string;
  lastName: string;
  middleName: string | null;
  avatar: string | null;
  email?: string;
}

export class ManageUserService extends AbstractBaseService<User> {
  protected __model: User = new User();

  public getResourceName(): string {
    return "manage/users";
  }

  public addUser(userData: IUserDTO) {
    return this.__client.post(this.__url, userData);
  }

  public editUser(userId: number, userData: IUserDTO) {
    return this.__client.patch(this.__url + "/" + userId, userData);
  }

  public changeStatus(userId: number, status: UserStatusEnum) {
    return this.__client.patch(this.__url + "/" + userId + "/status", {status:Boolean(status)});
  }

  public addUserToAdmin(userId: number) {
    return this.__client.post(this.__url + "/" + userId + "/roles/admins", null);
  }

  public removeUserFromAdmin(userId: number) {
    return this.__client.delete(this.__url + "/" + userId + "/roles/admins");
  }
}
